/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Bills_Hidden_SuspendedInputs */



/**
* | output |
* | --- |
* | "This customer is suspended, so its bills that were not invoiced yet are hidden here, as on every billing screen." |
*
* @param {Partner_Org_Bills_Hidden_SuspendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_bills_hidden_suspended = /** @type {((inputs?: Partner_Org_Bills_Hidden_SuspendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Bills_Hidden_SuspendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Kunde ist gesperrt. Seine noch nicht abgerechneten Rechnungen sind deshalb hier ausgeblendet, wie auf jeder Abrechnungsseite.")
	return /** @type {LocalizedString} */ ("This customer is suspended, so its bills that were not invoiced yet are hidden here, as on every billing screen.")
});